/*  ═══════════════════════════════════════════════════════════════════════════
    cart-reconcile.js — dev-build 519, 520 (Ben 20-10-2026)

    Every cart line's hire-period variant must match the booking's charged nights.
    Dates changed on a product page (or in another tab) updated the booking but left
    the lines on their old variant, so the cart could charge a week for a 1-night
    booking, or a night for a week.

    This runs on every page: on load, when the tab comes back into view, and after
    any booking change outside the cart page (the cart page re-prices itself on
    bookingbar:changed in pb-cart.js). It reads /cart.js and swaps any mismatched line
    to the right variant, one line at a time by line key, remove before add, keeping
    the line's properties — the same rules as pb-cart.js.
    ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__djwReconcile) return; window.__djwReconcile = true;
  var again = false, retryT = null;
  function want(n, label) {
    var l = (label || '').toLowerCase().trim(), m;
    if ((m = l.match(/^(\d+)\s+night/))) return n === +m[1];
    if ((m = l.match(/^(\d+)\s*-\s*(\d+)\s+night/))) return n >= +m[1] && n <= +m[2];
    if (l.indexOf('week') > -1) return n >= 4 && n <= 7;
    if (l.indexOf('month') > -1) return n >= 8;
    return null;
  }
  function post(u, b) { return realFetch(u, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(b) }); }
  function hireIdx(p) { return (p.options || []).findIndex(function (o) { var n = (typeof o === 'string' ? o : (o.name || '')).toLowerCase(); return n.indexOf('hire') > -1 || n.indexOf('period') > -1; }); }
  function busy(on) {
    var box = document.querySelector('.bc-detail-body-total-container');
    if (box) box.classList.toggle('is-d5-loading', on);
    document.documentElement.classList.toggle('djw-reconciling', on);
  }
  var inflight = null;
  function reconcile(reason, given) {
    /*  547: only the tab where the change was made re-prices. A tab refreshing from
        another tab's change, or waiting while another tab is mid-change, does nothing —
        it saw the cart holding both lines for a moment and "combined" them into 2. */
    var cs = window.cartStore;
    if (window.__djwLeaving) return Promise.resolve(false);   /* 557: page is reloading */
    if (cs && ((cs.syncing && cs.syncing()) || (cs.remoteBusy && cs.remoteBusy()))) {
      /*  569: busy elsewhere — try again shortly instead of dropping the check. */
      clearTimeout(retryT); retryT = setTimeout(function () { reconcile(reason); }, 1500);
      return Promise.resolve(false);
    }
    if (inflight) { again = true; return inflight; }
    /*  551: when a re-price finishes, hand the finished cart straight to the store so the
        change is announced at once — it used to be noticed by a poll up to ~2s later. */
    /*  561: the whole re-price runs inside the cross-tab lock, on a cart read fresh
        INSIDE the lock — so it always acts on the real cart, never on a copy another
        tab has since changed, and no other tab can write until it has finished. */
    inflight = (cs && cs.exclusive ? cs.exclusive(function () { return doReconcile(reason, given); }) : doReconcile(reason, given)).then(function (c) { inflight = null;
      if (!again && cs && cs.settleWith) { var done = window.__djwRepricedCart || null; window.__djwRepricedCart = null; cs.settleWith(done); } if (again) { again = false; return reconcile('queued').then(function (c2) { return c || c2; }); } return c; });
    return inflight;
  }
  /*  571: Storefront API. The token is Shopify's PUBLIC storefront token (Headless
      channel) — made to be shipped in a browser; it can only do what a shopper can. */
  var SF_TOKEN = '82e80553c4f6198f8f436b70e813dd7c', SF_VER = '2025-07';
  function sf(query, variables) {
    return realFetch('/api/' + SF_VER + '/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN }, body: JSON.stringify({ query: query, variables: variables }) }).then(function (x) { return x.json(); });
  }
  var sfLines = null, sfPending = null;
  /*  572: the line list is asked for as soon as a check starts, alongside the sums. */
  function prefetchLines(cart) {
    sfPending = { token: cart.token, p: sf('query($id:ID!){cart(id:$id){lines(first:100){nodes{id quantity merchandise{... on ProductVariant{id}} attributes{key value}}}}}', { id: 'gid://shopify/Cart/' + cart.token }).catch(function () { return null; }) };
  }
  async function swapLine(cart, it, nv) {
    var cartId = 'gid://shopify/Cart/' + cart.token;
    if (!sfLines || sfLines.token !== cart.token) {
      var q = (sfPending && sfPending.token === cart.token) ? await sfPending.p : await sf('query($id:ID!){cart(id:$id){lines(first:100){nodes{id quantity merchandise{... on ProductVariant{id}} attributes{key value}}}}}', { id: cartId }).catch(function () { return null; });
      var nodes = q && q.data && q.data.cart && q.data.cart.lines.nodes;
      if (!nodes) return false;
      sfLines = { token: cart.token, nodes: nodes };
    }
    var props = JSON.stringify(it.properties || {});
    var line = sfLines.nodes.find(function (l) {
      if (l.merchandise.id !== 'gid://shopify/ProductVariant/' + it.variant_id) return false;
      var a = {}; (l.attributes || []).forEach(function (x) { a[x.key] = x.value; });
      return JSON.stringify(a) === props || sfLines.nodes.filter(function (m) { return m.merchandise.id === l.merchandise.id; }).length === 1;
    });
    if (!line) return false;
    var u = await sf('mutation($id:ID!,$lines:[CartLineUpdateInput!]!){cartLinesUpdate(cartId:$id,lines:$lines){cart{id} userErrors{message}}}', { id: cartId, lines: [{ id: line.id, merchandiseId: 'gid://shopify/ProductVariant/' + nv.id, quantity: it.quantity }] }).catch(function () { return null; });
    var res = u && u.data && u.data.cartLinesUpdate;
    if (!res || (res.userErrors && res.userErrors.length)) { if (res) console.error('[cart-reconcile]', JSON.stringify(res.userErrors)); return false; }
    line.merchandise.id = 'gid://shopify/ProductVariant/' + nv.id;
    return true;
  }
  async function doReconcile(reason, given) {
    sfLines = null; sfPending = null;
    var changed = false;
    try {
      var cart = (given && given.items) ? given : (window.cartStore && window.cartStore.fresh) ? await window.cartStore.fresh() : await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      var n = parseInt((cart.attributes || {})['Charged nights'], 10);
      if (!cart.items || !cart.items.length || !(n > 0)) return;
      if (cart.token && window.djwNeedsReprice(cart, n) !== false) prefetchLines(cart);
      var todo = [];
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        var p = (window.pbCartProducts && window.pbCartProducts[it.handle]) || await fetch('/products/' + it.handle + '.js').then(function (r) { return r.json(); }).catch(function () { return null; });
        if (!p) continue;
        var hi = hireIdx(p); if (hi < 0) continue;
        var cur = (it.variant_options || [])[hi];
        if (want(n, cur) !== false) continue;
        var nv = p.variants.find(function (v) {
          if (want(n, v.options[hi]) !== true) return false;
          return (it.variant_options || []).every(function (o, k) { return k === hi || v.options[k] === o; });
        });
        if (nv && nv.id !== it.variant_id) todo.push({ it: it, nv: nv });
      }
      if (!todo.length) return;
      busy(true);
      for (var j = 0; j < todo.length; j++) {
        var t = todo[j];
        /*  520: if the right variant is already a line (same options, same properties), the
            quantities are combined on that line rather than leaving two lines of the same
            product at different prices. */
        var twin = cart.items.find(function (x) { return x.variant_id === t.nv.id && JSON.stringify(x.properties || {}) === JSON.stringify(t.it.properties || {}); });
        /*  522: combining raises the existing line first and only then removes the old one,
            so a refusal can't lose a pack. A plain swap that's refused puts the old line back. */
        if (twin) {
          /*  561: a line on the wrong hire length WITH its twin already on the right one
              can only mean a re-price that was cut off after its add (we hold the lock, so
              no re-price is running anywhere). The twin already carries the quantity —
              the add copied it — so the leftover is removed and nothing is added up. */
          var rmo = await post('/cart/change.js', { id: t.it.key, quantity: 0 });
          if (rmo.ok) console.info('[cart-reconcile] removed leftover', t.it.product_title, '→ kept', t.nv.title, 'x' + twin.quantity);
          else console.error('[cart-reconcile] could not remove leftover', t.it.product_title, rmo.status);
        } else {
          /*  571: re-price IN PLACE — the line keeps its identity and only its hire length
              changes (Storefront API cartLinesUpdate). Add-then-remove gave the line a new
              identity, and an open checkout then re-submitted the old one: that was the
              duplicate. Tested 21-10 with checkout open — correct on every refresh. */
          var ok = await swapLine(cart, t.it, t.nv);
          if (!ok) { console.error('[cart-reconcile] could not re-price', t.it.product_title, '— left as it was'); continue; }
          console.info('[cart-reconcile] re-priced', t.it.product_title, '→', t.nv.title);
        }
        changed = true;
      }
      if (changed) {
        /*  571: one request brings back the new cart AND the redrawn page/drawer. */
        var secs = 'pb-cart-drawer-body', surl = '/';
        if (reason === 'cartpage') {
          var names = (window.bookingRowSections || []).filter(Boolean);
          var ids = [].slice.call(document.querySelectorAll('[id^="shopify-section-"]')).map(function (el) { return el.id.replace('shopify-section-', ''); }).filter(function (id) { return names.some(function (nm) { return id === nm || id.slice(-(nm.length + 2)) === '__' + nm; }); });
          if (ids.length) { secs = ids.join(','); surl = '/cart'; }
        }
        try {
          var rs = await post('/cart/update.js', { sections: secs, sections_url: surl });
          var res = await rs.json();
          if (res && res.items) window.__djwRepricedCart = res;
          if (res && res.sections) { if (res.sections['pb-cart-drawer-body']) window.__djwNextDrawerHtml = res.sections['pb-cart-drawer-body']; if (reason === 'cartpage') window.__djwRepricedSections = res.sections; }
        } catch (e) {}
      }
    } catch (e) { console.error('[cart-reconcile]', e); }
    finally {
      if (changed) {
        document.dispatchEvent(new CustomEvent('cart:reconciled', { detail: { reason: reason } }));
        if (/\/cart\/?$/.test(location.pathname) && reason !== 'tab' && reason !== 'cartpage') { location.reload(); return changed; }
        if (typeof window.refreshCartDrawerIfOpen === 'function') { try { window.refreshCartDrawerIfOpen(); } catch (e) {} }
        /*  521: the product page's "Already added to your booking" panel kept the old
            price/line after a swap. Its section is re-fetched and the panel replaced. */
        refreshBooked(); refreshCount();
      }
      busy(false);
    }
    return changed;
  }
  function refreshBooked() {
    var panel = document.querySelector('.pp-booking-card-booked-info'); if (!panel) return Promise.resolve();
    var sec = panel.closest('[id^="shopify-section-"]'); if (!sec) return Promise.resolve();
    var id = sec.id.replace('shopify-section-', '');
    return realFetch(location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' }).then(function (x) { return x.text(); }).then(function (html) {
      var nu = new DOMParser().parseFromString(html, 'text/html').querySelector('.pp-booking-card-booked-info');
      var cur = document.querySelector('.pp-booking-card-booked-info');
      if (!cur) return;
      /*  523: when the item was removed in another tab, the new render has no rows. The
          panel is hidden (not emptied), so no blank card is left behind, and the card's
          button goes back to "Add to booking". */
      var rows = nu && nu.querySelector('.bkr');
      if (!rows) { cur.classList.remove('is-visible'); cur.hidden = true; cur.innerHTML = ''; return; }
      cur.hidden = false; cur.innerHTML = nu.innerHTML; cur.className = nu.className; cur.classList.add('is-visible');
    }).catch(function () {});
  }
  window.djwRefreshBooked = refreshBooked;
  /*  523: the header bag's count/dot is server-rendered, so a change made in another tab
      left the dot showing. It's set from /cart.js on every catch-up and after any change. */
  function refreshCount() {
    return realFetch('/cart.js', { credentials: 'same-origin' }).then(function (x) { return x.json(); }).then(function (c) {
      var n = c.item_count || 0;
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
    }).catch(function () {});
  }
  window.djwRefreshCount = refreshCount;
  window.djwReconcileCart = reconcile;
  /*  568: a quick, no-request answer to "will these dates move any line to another hire
      length?", from product data already on the page. true / false, or null if unsure. */
  window.djwNeedsReprice = function (cart, n) {
    if (!cart || !cart.items || !(n > 0)) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i], p = window.pbCartProducts && window.pbCartProducts[it.handle];
      if (!p) return null;
      var hi = hireIdx(p); if (hi < 0) continue;
      if (want(n, (it.variant_options || [])[hi]) === false) return true;
    }
    return false;
  };
  /*  520: the cart was only checked on load, on tab return and after a date change, so a
      line added from another tab with an older booking never got checked. Any cart write
      that isn't ours now schedules one check, 700ms after the writes stop. */
  var realFetch = window.fetch.bind(window), soonT = null;
  window.fetch = function (u, o) {
    var p = realFetch.apply(window, arguments);
    var url = String(u && u.url || u || ''), m = ((o && o.method) || (u && u.method) || 'GET').toUpperCase();
    if (m === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      if (!window.__djwCheckCovered) p.then(function () { clearTimeout(soonT); soonT = setTimeout(function () { reconcile('write'); }, (window.cartStore && window.cartStore.holding && window.cartStore.holding()) ? 0 : 700); }, function () {});
    }
    return p;
  };
  var onCart = /\/cart\/?$/.test(location.pathname);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { reconcile('load'); }); else reconcile('load');
  /*  522 — TAB CATCH-UP. Coming back to a tab: placeholders on everything that shows the
      booking, Add to booking blocked, then one ordered pass (booking → items → drawer,
      "Already added", option prices / cart page), then the placeholders come off together. */
  var cs = document.createElement('style');
  cs.textContent = 'html.djw-catchup .pp-booking-card-booked-info,html.djw-catchup .pp-bcm-x-v__price,html.djw-catchup .bc-detail-body-gear{opacity:.45;transition:opacity .15s;pointer-events:none}' +
    'html.djw-catchup .pp-booking-card-price,html.djw-catchup .pp-booking-card-total-price,html.djw-catchup .bc-detail-body-total-price{color:transparent!important;border-radius:6px;background:linear-gradient(90deg,#e6e6ec 0,#f3f3f6 50%,#e6e6ec 100%);background-size:200px 100%;animation:djwCu 1.2s linear infinite}' +
    'html.djw-catchup .pp-booking-card-btn,html.djw-catchup [data-pp-add],html.djw-catchup .pp-booking-card-cta{pointer-events:none!important;opacity:.55}' +
    '@keyframes djwCu{from{background-position:-200px 0}to{background-position:200px 0}}';
  document.head.appendChild(cs);
  var cuRunning = false;
  async function catchUp() {
    if (cuRunning) return; cuRunning = true;
    var html = document.documentElement; html.classList.add('djw-catchup');
    var onCart = /\/cart\/?$/.test(location.pathname), changed = false;
    try {
      if (typeof window.bbSyncFromCart === 'function') { try { await window.bbSyncFromCart(); } catch (e) {} }
      changed = await reconcile('tab');
      if (onCart) { if (changed) { location.reload(); return; } if (typeof window.djwD5Refresh === 'function') window.djwD5Refresh(); }
      if (typeof window.refreshCartDrawerIfOpen === 'function') { try { await window.refreshCartDrawerIfOpen(); } catch (e) {} }
      await refreshBooked();
      await refreshCount();
      if (typeof window.ppbRepriceOptions === 'function') window.ppbRepriceOptions();
      if (typeof window.updateCTAState === 'function') { try { window.updateCTAState(); } catch (e) {} }
    } catch (e) { console.error('[cart-reconcile] catch-up', e); }
    finally { html.classList.remove('djw-catchup'); cuRunning = false; }
  }
  window.djwCatchUp = catchUp;
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') catchUp(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) catchUp(); });
  document.addEventListener('bookingbar:changed', function () { if (!onCart) setTimeout(function () { reconcile('dates'); }, 400); });
})();
